import { ListTile } from '@tmov/design-system';
import { CloseBig, Edit } from '@tmov/design-system/icons';
import PropTypes from 'prop-types';
import React from 'react';

import { useListaDocumentosContext } from '../../../../../../../../contexts/ListaDocumentos';
import colors from '../../../../../../../../styles/colors';
import { GridDadosItem } from '../../../../../DadosGerais/styles';
import { BaixarTodosButton } from './BaixarTodosButton';
import DownloadDocumento from './DownloadDocumento';
import { IconButton } from './styles';
import SubtitleDocumento from './SubtitleDocumento';

function TabDocumentos({ protocolo, documentosMotorista, idLoteConjunto }) {
  const { listaDocumentos, editDocumentoAction } = useListaDocumentosContext();

  const enableEdit = documentos => {
    const docShipper = documentos.filter(doc => doc.idUsuarioShipper);
    return !!docShipper.length;
  };

  const hasDocumentos = () =>
    Object.keys(documentosMotorista).length > 0 || listaDocumentos.length > 0;

  return (
    <GridDadosItem>
      {hasDocumentos() && <BaixarTodosButton idLoteConjunto={idLoteConjunto} />}
      {listaDocumentos.map(item => (
        <ListTile
          key={item.tipoDocumento}
          title={item.tipoDocumentoDescricao}
          subtitle={<SubtitleDocumento {...item} protocolo={protocolo} />}
          icons={
            !!item.documentos.length &&
            !item.loading && (
              <>
                {item.anexarEnable && enableEdit(item.documentos) && (
                  <IconButton
                    data-testid="icon-button-edit"
                    type="button"
                    onClick={() => {
                      editDocumentoAction(item.tipoDocumento);
                    }}
                  >
                    {!item.editing ? (
                      <Edit color={colors.tmov_green} aria-label="edit" />
                    ) : (
                      <CloseBig color={colors.tmov_green} aria-label="close" />
                    )}
                  </IconButton>
                )}
                {!item.editing && (
                  <DownloadDocumento documentos={item.documentos} />
                )}
              </>
            )
          }
        />
      ))}
    </GridDadosItem>
  );
}

const documentosMotoristaShape = PropTypes.shape({
  id: PropTypes.number,
  tipoDocumentoDescricao: PropTypes.string.isRequired,
  tipoDocumento: PropTypes.string.isRequired,
  dataCriacao: PropTypes.string,
  isMaxicon: PropTypes.bool,
  link: PropTypes.string,
  idUsuario: PropTypes.number,
  idUsuarioShipper: PropTypes.number,
});

TabDocumentos.propTypes = {
  documentosMotorista: PropTypes.arrayOf(documentosMotoristaShape).isRequired,
  protocolo: PropTypes.string.isRequired,
  idLoteConjunto: PropTypes.number.isRequired,
};

TabDocumentos.defaultProps = {};

export default TabDocumentos;
